import { Box, Container } from "@radix-ui/themes";
import { MarkdownViewer } from "../common/MarkdownViewer";
import { PublicPageLayout } from "../layout/PublicPageLayout";

export function PrivacyPolicy() {
  return (
    <PublicPageLayout gradientBackground={false}>
      <Container size="3" py="6">
        <Box px="4">
          <MarkdownViewer contentKey="privacy-policy" />
        </Box>
      </Container>
    </PublicPageLayout>
  );
}
